module.exports = __webpack_public_path__ + "static/media/slider-l1-768.790218f3.webp";